import React from 'react';
import {
  Modal,
  CloseButton,
  ActionIcon,
  Box,
  Center,
  Flex,
  Loader,
} from '@mantine/core';
import { InlineIcon } from '@iconify/react';
import { useAiCoachAssistantStore } from 'store/aiCoachAssistantStore';
import { useAssistantModalStyles } from './AssistantModal.styles';
import { UserList } from './UserList';
import { Chat } from './Chat';
import { Landing } from './Landing';

// Member chat pulls in stream-chat-react and its stylesheet; the FAB is mounted
// on every page, so it stays out of the main chunk until a coach opens it.
const MemberChatPanel = React.lazy(
  () => import('./MemberChat/MemberChatPanel')
);

export const AssistantModal = () => {
  const { classes } = useAssistantModalStyles();
  const isOpen = useAiCoachAssistantStore((s) => s.isOpen);
  const chatMode = useAiCoachAssistantStore((s) => s.chatMode);
  const displayMode = useAiCoachAssistantStore((s) => s.displayMode);
  const close = useAiCoachAssistantStore((s) => s.close);
  const toggleDisplayMode = useAiCoachAssistantStore(
    (s) => s.toggleDisplayMode
  );
  const selectedUserId = useAiCoachAssistantStore((s) => s.selectedUserId);
  const isMemberChat = chatMode === 'member';

  return (
    <Modal
      opened={isOpen && displayMode === 'modal'}
      onClose={close}
      withCloseButton={false}
      closeOnClickOutside={false}
      padding={0}
      overlayProps={{ blur: 3, opacity: 0.5 }}
      styles={{
        content: {
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          borderRadius: 12,
          overflow: 'hidden',
        },
        body: {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
        },
      }}
      size="100%">
      <Box className={classes.header}>
        <Box className={isMemberChat ? classes.memberTitle : classes.title}>
          <InlineIcon
            icon={isMemberChat ? 'mdi:account' : 'mdi:robot-happy'}
            height={22}
          />
          {isMemberChat ? 'Member Chat' : 'AI Coach Assistant'}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <ActionIcon
            size="lg"
            onClick={toggleDisplayMode}
            title="Minimize to widget">
            <InlineIcon icon="tabler:arrows-minimize" height={18} />
          </ActionIcon>
          <CloseButton size="lg" onClick={close} />
        </Box>
      </Box>

      {isMemberChat ? (
        <React.Suspense
          fallback={
            <Center sx={{ flex: 1 }}>
              <Loader size="sm" />
            </Center>
          }>
          <MemberChatPanel />
        </React.Suspense>
      ) : (
        <Flex className={classes.body}>
          <Box className={classes.leftPanel}>
            <UserList />
          </Box>
          <Box className={classes.rightPanel}>
            {selectedUserId ? <Chat /> : <Landing />}
          </Box>
        </Flex>
      )}
    </Modal>
  );
};
